import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SystemConfig } from './system-config.model';
import { Breadcrumb, GenerateTableColumn } from 'src/app/shared/components';
import { ConfigService } from '../config.service';
import { catchErr } from 'src/app/shared/utils';

@Component({
    selector: 'app-system-config',
    templateUrl: './system-config.component.html',
    standalone: false
})
export class SystemConfigComponent implements OnInit {

    loading = true;
    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Configurações', route: '/configuracoes' },
        { label: 'Configurações do Sistema' },
    ]

    dataSource: SystemConfig[];
    columns: GenerateTableColumn[] = [
        { header: 'Nome', attr: 'nome' },
        { header: 'Valor', attr: 'valor' },
        { header: 'Tipo', attr: 'tipo' },
        { header: 'Descrição', attr: 'descricao' },
        {
            tdClass: 'td-w-auto',
            btnProps: { label: 'Editar' },
            click: {
                action: (rowData: SystemConfig) => this.router.navigateByUrl(`/configuracoes/${rowData.id}/editar`)
            }
        }
    ]

    constructor(
        private configService: ConfigService,
        private router: Router,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.configService.findAll<SystemConfig>().subscribe({
            next: (res) => this.dataSource = res,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }
}
